export const getReadingTime = minute => {
  const roundedMinute = Math.round(minute)

  return `${roundedMinute < 1 ? 1 : roundedMinute} dk`
}
